import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-user-form',
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.css'],
    standalone: false
})
export class UserFormComponent implements OnInit {
	@Output() userAdded = new EventEmitter();
	userForm: UntypedFormGroup;

  constructor() { }

  ngOnInit() {
  	 this.userForm = new UntypedFormGroup({
            name: new UntypedFormControl('', Validators.required),
            email: new UntypedFormControl('', Validators.required),
            role: new UntypedFormControl('', Validators.required)
        });
  }

  addUser() {
  	const userToAdd = this.userForm.value;
  	this.userAdded.emit(userToAdd);
  }

}
